import axios from "axios";
import serverMessage from "../server-message";

/**
 * Rev 4: a company holds exactly one bundle. Passing a bundleId of -1 (or any
 * value <= 0) detaches the bundle and keeps the already-materialised grants.
 *
 * This is the write that actually moves a company onto a bundle, and it can be
 * reached with a bundle that was only just created — a rejection here means a
 * bundle now exists that nobody holds, which the admin has to be told. The
 * setCompanyBundle middleware alerts action.payload, so reject with the server's
 * reason rather than axios's status-code string.
 */
export default function setCompanyBundle({ id, bundleId }) {
  return new Promise((resolve, reject) => axios
    .post(`/account/system-admin/api/v1/company-bundle/${id}`, {
      bundle_id: bundleId,
    })
    .then((response) => resolve(response.data))
    .catch((error) => reject(serverMessage(error))));
}
